import { OrgResponse } from './../../../business/entities/organization/OrgResponse';
import { createContext, useContext } from 'react';
import { ProposalForm, ProposalBlockForm } from './ProposalForm';
import { ProposalBuilderPageBloc } from './ProposalBuilderPageBloc';
import { ProposalPreviewPageBloc } from '../ProposalPreviewPage/ProposalPreviewPageBloc';
import { UserResponse } from '@business/entities/account';
import { ContactResponse } from '@business/entities/contact';
import { BrandResponse } from '@business/entities/brand';
import { CompanyResponse } from '@business/entities/companies';
import { ProposalPreviewPageBloc as ProposalPreviewPageBloc2 } from '@modules/proposals/ViewProposalModal/ProposalPreviewPage/ProposalPreviewPageBloc';
import { MultiplePreviewBlockBloc } from '../Blocks/BlockBase/MultiplePreviewBlock/MultiplePreviewBlockBloc';
import { ProposalStatus } from '@business/entities/proposal';

interface ProposalContextType {
  form: ProposalForm;
  currentSection: number;
  bloc: ProposalBuilderPageBloc | ProposalPreviewPageBloc | ProposalPreviewPageBloc2 | MultiplePreviewBlockBloc;
  scale: number;
  setScale: (scale: number) => void;
  sidebar: boolean;
  toggleSidebar: () => void;
  signee?: any;
  taxAfterDiscount?: boolean;
  combineLabor?: boolean;
  //   history: ProposalFormData[];
}

export const ProposalContext = createContext<ProposalContextType | null>(null);

export function useProposalContext() {
  return useContext(ProposalContext);
}

interface ProposalBlockContextType {
  blockForm: ProposalBlockForm;
  blockIndex: number;
}

export const ProposalBlockContext = createContext<ProposalBlockContextType | null>(null);

export function useProposalBlockContext() {
  return useContext(ProposalBlockContext);
}

export interface ProposalDataType {
  user?: UserResponse | null;
  organization?: OrgResponse | null;
  contact?: ContactResponse;
  company?: CompanyResponse;
  brand?: BrandResponse;
  dateSumitted: number;
  dateAccepted?: number;
  total: number;
  grandTotal?: number;
  signee?: any;
  senders?: any[];
  status?: ProposalStatus;
}

export const ProposalDataContext = createContext<ProposalDataType | null>(null);

export function useProposalDataContext() {
  return useContext(ProposalDataContext);
}
